// src/data/faq.js
// FAQ-Daten für verschiedene Produkte und Seiten
// Diese werden von der FAQ-Komponente genutzt und automatisch als Schema.org FAQPage ausgegeben

export const FAQ_BETONROHRFALLE = [
    {
        question: "Welche Tiere kann ich mit der Betonrohrfalle fangen?",
        answer: "Die Betonrohrfalle eignet sich hervorragend für den Lebendfang von Fuchs, Waschbär, Dachs, Marder und Marderhund. Die Rohrdurchmesser von 25 cm oder 30 cm sind optimal auf diese Wildarten abgestimmt."
    },
    {
        question: "Wie lange dauert der Aufbau der Betonrohrfalle?",
        answer: "Mit zwei Personen ist die Falle in etwa 30-45 Minuten aufgebaut. Durch das durchdachte System ist kein Betonfundament erforderlich – ein ebener, fester Untergrund genügt."
    },
    {
        question: "Brauche ich ein Betonfundament für die Falle?",
        answer: "Nein, ein Betonfundament ist nicht notwendig. Die Falle wird direkt auf den Boden gestellt. Bei sehr unebenem Gelände empfehle ich, den Boden vorher etwas zu begradigen."
    },
    {
        question: "Wie schwer ist die Betonrohrfalle?",
        answer: "Die einzelnen Betonrohre wiegen jeweils etwa 85-125 kg und sind zu zweit handhabbar. Der Versand erfolgt per Spedition."
    },
    {
        question: "Kann die Falle auch mobil eingesetzt werden?",
        answer: "Ja, die Falle kann umgesetzt werden. Allerdings ist sie aufgrund des Gewichts primär für stationäre Standorte konzipiert. Für häufige Standortwechsel empfehle ich die 25cm-Variante, die etwas leichter ist."
    },
    {
        question: "Welcher Köder funktioniert am besten?",
        answer: "Bewährt haben sich: rohe Eier (eines leicht angeschlagen), Frolic-Köderringe, Fischreste oder Hühnerinnereien. In der Ranzzeit wirkt der Blaseninhalt einer ranzigen Fähe besonders gut. Wichtig: Regelmäßig alle 1-2 Wochen nachködern!"
    },
    {
        question: "Wie oft muss ich die Falle kontrollieren?",
        answer: "Laut Tierschutzgesetz muss eine Lebendfalle mindestens einmal täglich, idealerweise morgens, kontrolliert werden. Mit einem elektronischen Fallenmelder (CatchAlive) können Sie sich benachrichtigen lassen und sparen Leerfahrten."
    },
    {
        question: "Ist die Betonrohrfalle tierschutzkonform?",
        answer: "Ja, die Falle ist zu 100% tierschutzkonform und für den Lebendfang zugelassen. Es gibt keine beweglichen Teile im Inneren, an denen sich das Tier verletzen könnte. Die Tiere werden lebend und unverletzt gefangen."
    },
    {
        question: "Welchen Fallenmelder kann ich verwenden?",
        answer: "Die Falle ist kompatibel mit allen gängigen Fallenmeldern wie CatchAlive, Trapmaster oder MinkPolice. Der Melder wird im Auslösebereich montiert und meldet einen Fang sofort per App-Benachrichtigung, SMS oder E-Mail."
    },
    {
        question: "Wie entnehme ich das gefangene Tier?",
        answer: "Mit dem passenden Abfangkasten und einer Schubstange wird das Tier sicher und stressfrei aus der Falle in den Transportbehälter geleitet. Eine ausführliche Anleitung mit Video finden Sie auf unserer Seite unter 'Aufbau'."
    },
    {
        question: "Was ist der Unterschied zwischen 25cm und 30cm Rohrdurchmesser?",
        answer: "Die 30cm-Variante ist ideal für größere Wildarten wie Fuchs und Dachs. Die 25cm-Variante ist etwas leichter und günstiger, eignet sich aber ebenfalls für Fuchs, Waschbär und Marder. Für reine Marderbejagung reicht 25cm völlig aus."
    },
    {
        question: "Wie funktioniert das Wipprohr-System?",
        answer: "Das Wipprohr in der Mitte der Falle kippt, sobald ein Tier es betritt. Dadurch fallen beidseitig die Schieber herunter und verschließen die Falle. Das System ist extrem zuverlässig und funktioniert bei jedem Wetter."
    },
    {
        question: "Kann ich die Falle auch eingraben?",
        answer: "Ja, die Falle kann teilweise eingegraben oder mit Erdreich, Reisig und Laub verblendet werden. Das erhöht die Annahme durch das Wild erheblich. Wichtig: Auslöse- und Kontrollbereich müssen zugänglich bleiben."
    },
    {
        question: "Wie lange hält eine Betonrohrfalle?",
        answer: "Bei ordnungsgemäßer Pflege hält die Falle praktisch unbegrenzt. Die Betonrohre sind witterungsbeständig, die Metallteile verzinkt. Viele meiner Fallen sind seit über 30 Jahren im Einsatz – ohne nennenswerte Verschleißerscheinungen."
    },
    {
        question: "Gibt es eine Garantie auf die Falle?",
        answer: "Die Betonrohre sind praktisch unverwüstlich. Bei Fragen oder Problemen stehe ich Ihnen jederzeit telefonisch zur Verfügung – auch Jahre nach dem Kauf."
    }
];

export const FAQ_ABFANGKASTEN = [
    {
        question: "Wofür brauche ich einen Abfangkasten?",
        answer: "Der Abfangkasten dient zur sicheren und stressfreien Entnahme des gefangenen Wildes aus der Betonrohrfalle. Er wird am Fallenausgang arretiert und das Tier wird mit einer Schubstange hineingetrieben."
    },
    {
        question: "Aus welchem Material besteht der Abfangkasten?",
        answer: "Der Abfangkasten ist aus stabilem, verzinktem Stahlblech gefertigt. Er ist robust, langlebig und witterungsbeständig."
    },
    {
        question: "Passt der Abfangkasten zu allen Betonrohrfallen?",
        answer: "Der Abfangkasten ist passgenau auf meine Betonrohrfallen abgestimmt. Für andere Fabrikate kann ich die Kompatibilität nicht garantieren – sprechen Sie mich bei Unsicherheit einfach an."
    }
];

export const FAQ_ALLGEMEIN = [
    {
        question: "Wie kann ich bestellen?",
        answer: "Sie können direkt über unseren Online-Shop bestellen oder mich telefonisch kontaktieren. Für größere Bestellungen oder spezielle Anfragen erstelle ich Ihnen gerne ein individuelles Angebot."
    },
    {
        question: "Wie erfolgt der Versand?",
        answer: "Kleinere Artikel wie Schubstangen oder Fallenmelder versenden wir per DHL. Betonrohrfallen und Abfangkästen werden aufgrund von Größe und Gewicht per Spedition geliefert. Selbstabholung ist nach Terminabsprache jederzeit möglich."
    },
    {
        question: "Welche Zahlungsmethoden werden akzeptiert?",
        answer: "Wir akzeptieren Zahlung per PayPal, Überweisung und bei Abholung auch Barzahlung."
    },
    {
        question: "Bieten Sie auch Beratung an?",
        answer: "Ja, selbstverständlich! Ich berate Sie gerne telefonisch zu Fallenauswahl, Standortwahl, Köderung und allen anderen Fragen rund um die Fallenjagd. 40 Jahre Praxiserfahrung stehen Ihnen zur Verfügung."
    },
    {
        question: "Brauche ich einen Jagdschein für die Fallenjagd?",
        answer: "Ja, in Deutschland ist für die Fallenjagd ein gültiger Jagdschein und in den meisten Bundesländern zusätzlich ein Fallenjagdschein (Sachkundenachweis) erforderlich. Informieren Sie sich über die Regelungen in Ihrem Bundesland."
    }
];
